// src/hooks/useOnScreen.js
import { useEffect, useRef, useState } from "react"

export const useOnScreen = (options) => {
  const ref = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      // Update our state when the element is intersecting
      if (entry.isIntersecting) {
        setIsVisible(true)
        // We can unobserve after it's visible to prevent re-triggering
        observer.unobserve(entry.target)
      }
    }, options)

    const currentElement = ref.current
    if (currentElement) {
      observer.observe(currentElement)
    }

    // Cleanup function to unobserve the element
    return () => {
      if (currentElement) {
        observer.unobserve(currentElement)
      }
    }
  }, [ref, options])

  return [ref, isVisible]
}